const Checkout = () => import('@/pages/checkout/Checkout');
const CheckoutPolicies  = () => import('@/pages/checkout/CheckoutPolicies');
const CheckoutInfo = () => import('@/pages/checkout/CheckoutInfo');
const CheckoutQuotes = () => import('@/pages/checkout/CheckoutQuotes');
const CheckoutConfirm = () => import('@/pages/checkout/CheckoutConfirm');
const CheckoutVerify = () => import('@/pages/checkout/CheckoutVerify');
const CheckoutPayment = () => import('@/pages/checkout/CheckoutPayment');
const CheckoutSuccess = () => import('@/pages/checkout/CheckoutSuccess');

export default {
  path: '/checkout',
  component: Checkout,
  redirect: '/checkout/info',
  children: [
    // {
    //   path: 'policies',
    //   name: 'checkoutPolicies',
    //   component: CheckoutPolicies,
    //   meta: {
    //     requiresAuth: true
    //   },
    //   props: route => ({
    //     ...route.params
    //   }),
    //   beforeEnter: (to, from, next) => {
    //     if(!from.path.match('/insurance/') && !from.path.match('/login')){
    //       next('/');
    //     }
    //     else{
    //       next();
    //     }
    //   }
    // },
    {
      path: 'info',
      name: 'checkoutInfo',
      component: CheckoutInfo,
      meta: {
        requiresAuth: true
      },
      props: route => ({
        ...route.params
      }),
      beforeEnter: (to, from, next) => {
        //if ((!from.path.match('/Renewal/')&&!from.path.match('/login')  && !from.path.match('/checkout/')&&!from.path.match('/signup'))||(!from.path.match('/insurance/') && !from.path.match('/login') && !from.path.match('/checkout/') && !from.path.match('/signup/')))//
        if (!from.path.match('/partner')&&!from.path.match('/Renewal/')&&!from.path.match('/insurance/') && !from.path.match('/login') && !from.path.match('/checkout/') && !from.path.match('/signup/'))//
        {
          next('/');
          //console.log("3");
        }       
        else{
          //console.log("2");
          next();
        }
      }
    },
    {
      path: 'quotes',
      name: 'checkoutQuotes',
      component: CheckoutQuotes,
      meta: {
        requiresAuth: true
      },
      props: route => ({
        ...route.params
      }),
      beforeEnter: (to, from, next) => {
        if(!from.path.match('/checkout/')) {
          next('/');
        }else{
          next();
        }
      }
    },
    {
      path: 'confirm',
      name: 'checkoutConfirm',
      component: CheckoutConfirm,
      meta: {
        requiresAuth: true
      },
      props: route => ({
        ...route.params
      }),
      beforeEnter: (to, from, next) => {
        if(!from.path.match('/checkout/')) {
          next('/');
        }else{
          next();
        }
      }
    },
    {
      path: 'verify',
      name: 'checkoutVerify',
      component: CheckoutVerify,
      meta: {
        requiresAuth: true
      },
      props: route => ({
        ...route.params
      }),
      beforeEnter: (to, from, next) => {
        if(!from.path.match('/checkout/confirm')) {
          next('/');
        }else{
          next();
        }
      }
    },
    {
      path: 'payment',
      name: 'checkoutPayment',
      component: CheckoutPayment,
      meta: {
        requiresAuth: true
      },
      props: route => ({
        ...route.params
      }),
      beforeEnter: (to, from, next) => {
        if(!from.path.match('/checkout/verify')) {
          next('/');
        }else{
          next();
        }
      }
    },
    {
      path: 'success',
      name: 'checkoutSucc',
      component: CheckoutSuccess,
      props: route => ({
        ...route.params
      }),
      beforeEnter: (to, from, next) => {
        if(!from.path.match('/checkout/payment')) {
          next('/');
        }else{
          next();
        }
      }
    }
  ]
};